import { render, staticRenderFns } from "./SelectedChips.vue?vue&type=template&id=bb61be1c&scoped=true"
import script from "./SelectedChips.vue?vue&type=script&lang=js"
export * from "./SelectedChips.vue?vue&type=script&lang=js"
import style0 from "./SelectedChips.vue?vue&type=style&index=0&id=bb61be1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb61be1c",
  null
  
)

export default component.exports